/* dummy-input.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["innerRef"];
import "./dummy-input.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { removeProps } from '../../utils';
var dummyInputStyles = null;
export default function DummyInput(_ref) {
  var innerRef = _ref.innerRef,
    props = _objectWithoutProperties(_ref, _excluded);
  // Remove animation props not meant for HTML elements
  var filteredProps = removeProps(props, 'onExited', 'in', 'enter', 'exit', 'appear');

  // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
  return /*#__PURE__*/React.createElement("input", _extends({
    ref: innerRef,
    className: ax(["_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _nd5l1sux _12ji1r31 _1qu2glyw _12y3idpf _1bsbt94y _kqswh2mm _1n5d1j28 _syaz1j28 _1e02p1rm _tzy4idpf _t9ec1kuz", "-dummyInput"])
  }, filteredProps));
}